import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LandingPage from "./LandingPage";

const Home = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    
    if (!token) {
      // Sem token, mostrar landing page
      setIsAuthenticated(false);
      return;
    }

    // Verificar se é token válido
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      
      const payload = JSON.parse(jsonPayload);
      
      if (!payload.tenant_id) {
        // Token antigo, precisa limpar cache
        navigate("/clear-cache");
        return;
      }
      
      // Token válido, ir para dashboard
      setIsAuthenticated(true);
      navigate("/admin/welcome");
    } catch (error) {
      // Erro ao decodificar, mostrar landing
      localStorage.clear();
      setIsAuthenticated(false);
    }
  }, [navigate]);

  // Enquanto verifica autenticação
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-500"></div>
      </div>
    );
  }

  // Se não autenticado, mostrar landing page
  if (!isAuthenticated) {
    return <LandingPage />;
  }

  return null;
};

export default Home;
